/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum OpenUrlWith {
  IFrame = 'IFrame',
  SameTab = 'SameTab',
  NewTab = 'NewTab'
}
